import axios from 'axios';
import authHeader from './auth-header';
import CommonServices from './common-services'
const API_URL = CommonServices.extend_url('Auth/') /*'http://local.hyvaaftersell.care/api/Auth/';*/
const API_BASE = CommonServices.extend_url()
// const API_URL = 'https://v1qa-hyva.aftersell.care/api/Auth/';

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'login', {
        username: user.username,
        password: user.password,
        device_id: user.device_id,
      })
      .then(response => {
        if (response.data.token) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  login_otp_verify(otp_token) {
    return axios
      .post(API_BASE + 'kspgAPI/OtpVerify', {
        otp_token: otp_token,
        device:'web',
        device_id: 'NA',
      },{ headers: authHeader() })
      .then(response => {
        if (response.data.token) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
  get(url,params){
    return axios.get(API_BASE+url, {
      params: params
    });
  }
  put(url,params) {
    return axios.put(API_BASE+url,params);
  }
  putToken(url,formData,token) {    
            return  axios.put(API_BASE+ url,formData,
                    {headers: {
                        'X-API-KEY' : token
                    }
            });
  }
}

export default new AuthService();
